"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandedPackagingResponse = exports.BrandedPackagingStatus = exports.BrandedPackagingError = exports.BrandedPackagingTypeName = exports.BrandedPackagingType = void 0;
const business_types_1 = require("@deliverr/business-types");
Object.defineProperty(exports, "BrandedPackagingType", { enumerable: true, get: function () { return business_types_1.BrandedPackagingType; } });
Object.defineProperty(exports, "BrandedPackagingTypeName", { enumerable: true, get: function () { return business_types_1.BrandedPackagingTypeName; } });
Object.defineProperty(exports, "BrandedPackagingError", { enumerable: true, get: function () { return business_types_1.BrandedPackagingError; } });
Object.defineProperty(exports, "BrandedPackagingStatus", { enumerable: true, get: function () { return business_types_1.BrandedPackagingStatus; } });
class BrandedPackagingResponse {
    constructor(data, error) {
        this.data = data;
        this.error = error;
    }
}
exports.BrandedPackagingResponse = BrandedPackagingResponse;
//# sourceMappingURL=BrandedPackaging.js.map